import HorizontalTab from '../../../common/component/HorizontalTab';
import {SUB_TAB_HEIGHT_PX_V4} from '../../../common/scss/util/variable';
import {ISecondTabItem} from '../type';

interface IProps {
  secondTabSelected: string;
  secondTabList: ISecondTabItem[];
  onClickSecondTab: (tab: ISecondTabItem) => void;
}

export default function HomeSecondTabListV4({
  secondTabSelected,
  secondTabList,
  onClickSecondTab,
}: IProps) {
  return (
    <HorizontalTab
      keyName="key"
      textName="text"
      variant="transparentWhiteSmall"
      needTextTranslation
      currentTab={secondTabSelected}
      height={SUB_TAB_HEIGHT_PX_V4}
      tabList={secondTabList}
      onClickTab={onClickSecondTab}
      needScrollGradient
    />
  );
}
